import script from "./CartItemOrderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CartItemOrderDetail.vue?vue&type=script&setup=true&lang=js"

import "./CartItemOrderDetail.vue?vue&type=style&index=0&id=24272d60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24272d60"]])

export default __exports__